<template>
  <div class="append-box" @touchmove="gtouchmove">
    <div class="container" ondragstart="return false;">
      <div class="img-bg abs-center-box">
        <div class="circle-box abs-center-box">
          <img
            src="@/assets/img/pre-loading/pre_loading.png"
            class="img-logo"
          />
          <span class="loading-process-txt">{{ loadingProgress }}%</span>
          <div class="btn-refresh-box" v-show="showRefreshBtn">
            <btnRefresh
              class="btn-refresh"
              @refresh="handleRefresh"
              v-clickMusic
            ></btnRefresh>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import btnRefresh from "@/components/btnRefresh.vue";
import { reloadGame } from "@/logic/src/common";
export default {
  name: "preLoading",
  components: {
    btnRefresh,
  },
  data() {
    return {
      timer: null,
      showRefreshBtn: false,
    };
  },
  methods: {
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    handleRefresh() {
      reloadGame();
    },
    remove() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
  },
  mounted() {
    store.dispatch("setLoadingProgress", 0);
    // this.timer = window.setTimeout(() => {
    //   this.showRefreshBtn = true;
    //   window.clearTimeout(this.timer);
    // }, 10 * 1000);
  },
  computed: {
    loadingProgress() {
      return store.state.app.loadingProgress;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes play {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.append-box {
  z-index: 10009;
  .container {
    .img-bg {
      width: 0.6rem;
      height: 0.6rem;
      background-color: rgba(0, 0, 0, 0.8);
      border-radius: 0.1rem;
    }
    .circle-box {
      .img-logo {
        height: 0.475rem;
        width: 0.475rem;
        display: block;
        -webkit-animation: play 2s linear infinite;
        animation: play 2s linear infinite;
      }
      .loading-process-txt {
        font-size: 0.11rem;
        position: absolute;
        color: #ffffff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .btn-refresh-box {
        position: absolute;
        width: 0.69rem;
        height: 0.34rem;
        display: flex;
        left: 50%;
        top: 50%;
        transform: translate(-50%, 100%);
        .btn-refresh {
          flex: 1;
        }
      }
    }
  }
}
@media all and (orientation: portrait) {
  .append-box {
    .abs-center-box {
      transform: translate(-50%, -50%) rotate(90deg);
    }
    .container {
      .circle-box {
        .loading-process-txt {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%) rotate(-90deg);
        }
        .btn-refresh-box {
          position: absolute;
          width: 0.69rem;
          height: 0.34rem;
          display: flex;
          top: 50%;
          margin-left: 35%;
          transform: translateY(-50%) rotate(-90deg);
          .btn-refresh {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>